// measureCache.ts
import type { WaistSearchResult } from './waist';
import { measureObj } from './measureObj';  // your function above

const cache = new Map<string, Promise<WaistSearchResult>>();

export function getMeasurementFromModel(model: { obj: string; sessionID: string, inputHeightCm?: number }): Promise<WaistSearchResult> {
  const key = model.sessionID;            // or model.obj if you prefer
  if (!cache.has(key)) {
    // start the async job and cache the Promise
    cache.set(key, measureObj(model));
  }

  return cache.get(key)!;  // always defined after the set
}
